<template>
  <div
    class="base-dropdown"
    :class="{isOpen,  'icon-valid': (validacoes.searchItem)}">
    <div
      v-if="!isOpen"
      class="selectedItem"
      @click="openDropdown()">
      <span>{{ value }}</span>
      <svg
        class="expand_more"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        viewBox="0 0 24 24">
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
        <path
          fill="none"
          d="M0 0h24v24H0V0z" />
      </svg>
    </div>
    <div
      v-else
      class="list">
      <input
        v-if="searchInput"
        id="searchList"
        v-model="searchItem"
        :placeholder="placeholder"
        type="text"
        name="searchList"
        @input="validarCampo(searchItem)">
      <span
        v-for="(cont) in itemsFiltered"
        :key="cont.key"
        @click="selectItem(cont.key, cont.value)"
      >{{ cont.value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  data() {
    return {
      isOpen: false,
      searchItem: '',
      validacoes: {
        searchItem: false
      }
    }
  },
  props: {
    items: {
      type: Array,
      default: () => ''
    },
    selectedItem: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Selecione um item.'
    },
    externalSelect: {
      type: Function,
      default: undefined
    },
    valid: {
      type: Boolean,
      default: false
    },
    searchInput: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    value() {
      const { selectedItem, placeholder, items } = this;
      if(!selectedItem) {
        return placeholder;
      }
      const item = items.filter(i => i.key === selectedItem)[0]
      return item.value;
    },
    itemsFiltered() {
      return this.items.filter( i => i.value.toLocaleLowerCase().search(this.searchItem.toLocaleLowerCase()) >= 0)
    }
  },
  watch: {
    selectedItem() {
      if(!this.selectedItem) {
        this.validacoes.searchItem = false
        return this.validacoes.searchItem
      }
      return true
    }
  },
  methods: {
    selectItem(key, value) {
      this.isOpen = false;
      this.searchItem = '';

      this.externalSelect(key);
      this.validarCampo(key)

      const pathLocation = window.location.pathname.replaceAll("/", "")
      dataLayer.push({
        event: 'customEvent',
        eventCategory: `blog: ${pathLocation}`,
        eventAction: 'preencheu:calculadora-custo-cnpj',
        eventLabel: `atividade|${this.normalizeText(value)}`
      })
    },
    normalizeText(text) {
      return (text || '').normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replaceAll(' ','-')
      .replaceAll('/','e')
      .toLowerCase();
    },
    openDropdown() {
      this.isOpen = true;
      this.validacoes.searchItem = false
    },
    validarCampo(item) {
      this.validacoes.searchItem = item !== ''
    }
  }
}
</script>

<style scoped>
  .base-dropdown {
    background: #fff;
    color: #7c92ab;
    max-height: 40px;
    cursor: pointer;
    position: relative;
  }

  .base-dropdown .selectedItem {
    border: 1px solid #7c92ab;
    border-radius: 8px;
    padding: 8px 5px 9px 15px;
    position: relative;
    z-index: 100;
    background: #f5f7fb;
    display: flex;
    justify-content: space-between;
  }

  .base-dropdown .selectedItem span {
    display: block;
    padding: 0;
    margin-top: 5px;
  }

  .base-dropdown .selectedItem svg {
    float: right;
    height: 25px;
  }

  .base-dropdown.isOpen .list {
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 7px 15px;
    border: 1px solid #7c92ab;
    border-radius: 4px;
    z-index: 10;
    background: white;
    max-height: 240px;
    overflow: hidden auto;
    border-color: #5088e1 !important;
  }

  .base-dropdown.isOpen .list input {
    margin: 5px 0 20px;
    border-radius: 4px;
    border: 1px solid #7c92ab;
    padding: 5px 10px;
  }
  .base-dropdown.isOpen .list span {
    color: #7c92ab;
  }

  .base-dropdown.isOpen .list span:hover {
    color: #1b53ad;
  }

  .base-dropdown.isOpen .list::-webkit-scrollbar-track {
    background: #e2eaf3;
  }

  .base-dropdown.isOpen .list::-webkit-scrollbar-thumb {
    background-color: #002868;
    border-radius: 4px;
  }

  .base-dropdown.isOpen .list::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .icon-valid:after {
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 0 24 24' width='24px' fill='%2356BD5B'%3E%3Cpath d='M0 0h24v24H0V0z' fill='none'/%3E%3Cpath d='M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'/%3E%3C/svg%3E");
    display: block;
    position: absolute;
    font-size: 24px;
    top: 5px;
    right: 20px;
    z-index: 999;
  }
  .icon-valid .selectedItem{
    border-color: #56BD5B !important;
  }
  .icon-valid .selectedItem:focus {
    border-color: #56BD5B !important;
  }
</style>
